import PropTypes from 'prop-types';

import BlogList from '../../Blog/BlogList';

const BlogListingTemplate = ({ items, isEditMode }) => (
  <div className="listing variation-blog">
    <BlogList items={items} isEditMode={isEditMode} />
  </div>
);

BlogListingTemplate.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  isEditMode: PropTypes.bool,
};

BlogListingTemplate.defaultProps = {
  items: [],
  isEditMode: false,
};

export default BlogListingTemplate;
